import { render } from "./account-selector-modal.vue?vue&type=template&id=3afa55d3"
import script from "./account-selector-modal.vue?vue&type=script&lang=js"
export * from "./account-selector-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__